module.exports = __webpack_public_path__ + "static/media/Instagram.56688b8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/agent/Tabs/Payments/img/Instagram.svg
// module id = 383
// module chunks = 16